export default {
  Community: {
    editingCase: {
      titleTextareaPlaceholder: "Опишите кейс или задайте вопрос",
      sybmolCount: "Количество символов должно составлять от {min} до {max}",
      wordsCount: "Количество слов должно составлять от {min} до {max}",
      mobiledocPlaceholder:
        "Расскажите подробнее про данные обследования пациента",
      mobiledocLabel: "Данные обследования",
      tags: "Теги",
      editCase: "Редакировать кейс",
      anamnesisPlaceholder: "Расскажите подробнее про анамнез пациента",
      treatmentPlaceholder: "Расскажите подробнее про лечение пациента",
      caseNotesPlaceholder: "Расскажите подробнее про кейс",
      questionNotesPlaceholder: "Расскажите подробнее про вопрос",
      addImage: "Прикрепить изображение",
      anamnesis: "Анамнез",
      treatment: "Лечение",
      notes: "Дополнение",
    },
    uploader: {
      case: {
        title: "Добавить кейс",
        description: "Поделитесь интересными кейсами из вашей практики",
      },
      question: {
        title: "Задать вопрос",
        description: "Пользователи ответят быстрее, если вы выберете «Вопрос»",
      },
    },
    title: "Сообщество",
    description: "Обмен знаниями между врачами по клиническим случаям",
    all_cases: "Все кейсы",
    my_cases: "Мои кейсы",
    case: {
      shareLink: {
        1: "Посмотрите кейс",
        2: "на Платформе “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
    noCasesLang: {
      1: "На этом языке пока нет опубликованных кейсов",
      2: "Будьте первым, поделитесь исследованием в формате DICOM и узнайте мнение коллег!",
    },
    filter: {
      status: {
        placeholder: "Сортировка кейсов",
        values: {
          popular: "Сначала популярные",
          actual: "Сначала актуальные",
        },
        options: {
          base: "Показать сначала",
          popular: "Популярные",
          actual: "Актуальные",
        },
      },
      modality: {
        placeholder: "Модальность",
      },
      bodypart: {
        placeholder: "Область исследования",
      },
      sex: {
        placeholder: "Пол",
        values: {
          M: "Мужской",
          F: "Женский",
        },
      },
    },
  },
  h1_community: "Сообщество врачей",
};
